import '../card.scss';
import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ImageGenerator from '../../image-generator/image-generator';

function SeriesCard ({ data, isDragging = false }) {
	const history = useHistory();
	const startX = useRef(0);
	const startY = useRef(0);

	const handleMouseDown = (e) => {
		startX.current = e.clientX;
		startY.current = e.clientY;
	};

	const handleClick = (e) => {
		const dx = Math.abs(e.clientX - startX.current);
		const dy = Math.abs(e.clientY - startY.current);
		const distance = Math.sqrt(dx * dx + dy * dy);

		if (distance < 5) {
			history.push(`/series/${data.id || data.programId}`);
		} else {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	return (
		<Link className="content-item"
			  to={`/series/${data.id || data.programId}`}
			 onMouseDown={handleMouseDown} onClick={(e) =>{e.preventDefault(); e.stopPropagation(); handleClick(e)}}>
			<div>
				<div className="effect-poster">
					<ImageGenerator src={data.smallImage || data.image}
									name={data.title}/>
					<ImageGenerator src={data.smallImage || data.image}
									name={data.title}/>
				</div>
				<ImageGenerator src={data.smallImage || data.image}
								name={data.title}/>
				<span className="item-title text-truncate">{data.title}</span>
			</div>
		</Link>
	);
}

export default SeriesCard;
